import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ModalServiceView from "./ModalServiceView";

import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const animatedComponents = makeAnimated();

export default function CompletedTask(props: any) {
  const [id_value, SerIdValue] = useState(useParams());
  const [service_data, SetServiceData] = useState([]);
  const [rework_data, SetReworkData] = useState([]);
  const [sp_data, SetSPData] = useState([]);
  const [selected_sp, SetSelectedSP] = useState({ label: "All", value: "all" });
  const [type_data, SetTypeData] = useState([
    { label: "All", value: "all" },
    { label: "Invoiced", value: "invoiced" },
    { label: "Not Invoiced", value: "non_invoiced" },
  ]);
  const [selected_type, SetSelectedType] = useState({
    label: "All",
    value: "all",
  });
  const [total_data, SetTotalData] = useState({});
  const [from_date, SetFromDate] = useState("");
  const [to_date, SetToDate] = useState("");

  useEffect(() => {
    console.log("CompletedTask On mount :", props);
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    SetFromDate(firstDay);
    SetToDate(date);

    get_finished_task(selected_sp, selected_type, firstDay, date);
  }, []);

  async function get_finished_task(
    selected_sp_value,
    selected_type_value,
    from_date_value,
    to_date_value
  ) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        filter_from: moment(from_date_value).format("DD-MM-yyyy"),
        filter_to: moment(to_date_value).format("DD-MM-yyyy"),
      },
    };
    if (selected_sp_value.value != "all") {
      pass_data.get.sp_user = selected_sp_value.value;
    }
    if (selected_type_value.value != "all") {
      pass_data.get.filter = selected_type_value.value;
    }
    console.log(" get_finished_task pass data :", pass_data);
    let data = await api("/outlet/finished_order_tasks", pass_data);
    console.log("finished_order_tasks response :", data);

    if (data.status_code == 200) {
      SetTotalData(data.response);
      if (data.response.hasOwnProperty("services")) {
        SetServiceData(data.response.services);
      }
      if (data.response.hasOwnProperty("reworks")) {
        SetReworkData(data.response.reworks);
      }
      if (data.response.hasOwnProperty("service_providers")) {
        let option_data = [
          {
            label: "All",
            value: "all",
          },
        ];
        data.response.service_providers.map((ele: any, index: any) => {
          option_data.push({
            label: ele.name + "@" + ele.user_name,
            value: ele.id,
          });
        });
        SetSPData(option_data);
      }
    }
  }

  function capitalizeFirstLetter(string) {
    if (string != undefined) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

  return (
    <div>
      <div className="bg-fff p-4 row">
        <h6 className="mb-3 text-dark fw-bolder ">Completed Task</h6>

        <div className="mb-2 col-md-3">
          <label className="form-label">From Date</label>
          <DatePicker
            closeOnScroll={true}
            selected={from_date}
            onChange={(date) => {
              console.log("from date :", date);
              SetFromDate(date);
              get_finished_task(selected_sp, selected_type, date, to_date);
            }}
            dateFormat="dd-MM-yyyy"
            className="form-control"
            placeholderText="From Date"
            maxDate={to_date}
          />
        </div>
        <div className="mb-2 col-md-3">
          <label className="form-label">To Date</label>
          <DatePicker
            closeOnScroll={true}
            selected={to_date}
            onChange={(date) => {
              console.log("to date :", date);
              SetToDate(date);
              get_finished_task(selected_sp, selected_type, from_date, date);
            }}
            dateFormat="dd-MM-yyyy"
            className="form-control"
            placeholderText="To Date"
            minDate={from_date}
            maxDate={new Date()}
          />
        </div>

        <div className="mb-2 col-md-3">
          <label className="form-label">Invoice Type</label>
          <Select
            components={animatedComponents}
            className="basic-multi-select"
            classNamePrefix="select"
            value={selected_type}
            options={type_data}
            onChange={(e) => {
              console.log("SP on change :", e);
              SetSelectedType(e);
              get_finished_task(selected_sp, e, from_date, to_date);
            }}
          />
        </div>

        <div className="mb-2 col-md-3">
          <label className="form-label">Editors</label>
          <Select
            components={animatedComponents}
            className="basic-multi-select"
            classNamePrefix="select"
            value={selected_sp}
            options={sp_data}
            onChange={(e) => {
              console.log("SP on change :", e);
              SetSelectedSP(e);
              get_finished_task(e, selected_type, from_date, to_date);
            }}
          />
        </div>
      </div>
      <div className="container p-3 mt-8">
        <div className="card p-3">
          <div className="row py-2">
            <h5 className="fs-7 text-gray fw-bolder">Service</h5>
            <div className="d-flex">
              <p className="p-2">Total Services :{total_data.total_services}</p>
              <p className="p-2">
                Total Image Quantity :{total_data.total_services_item_qty}
              </p>
              <p className="p-2">
                Total Video Quantity :{total_data.total_services_duration_qty}
              </p>
            </div>

            {service_data.length > 0 ? (
              service_data.map((s_ele: any, s_index: any) => (
                <div className="col-md-6 mb-2" key={s_index}>
                  <div className="border p-3">
                    <h6 className="fs-7 mb-3">Task : {s_ele.task_name}</h6>

                    <div className="row align-items-center">
                      <div className="col-6 text-gray">
                        <p className="fs-7">Service : {s_ele.service_name}</p>
                      </div>
                      <div className="col-6 text-end text-gray">
                        <p className="fs-7">Client : {s_ele.client_name}</p>
                      </div>
                    </div>

                    <h6 className="text-dark fs-7 mb-3 fw-bolder">
                      {s_ele.customer_name}
                    </h6>
                    <p className="text-dark fs-7">
                      Finished By : {s_ele.finished_user} @{" "}
                      {s_ele.finished_username}
                    </p>
                    <div className="d-flex">
                      <p className="text-dark fs-7">
                        Quantity: {s_ele.quantity}
                      </p>
                      <p
                        className={
                          s_ele.invoiced
                            ? "yes-invoice fs-7 ms-auto"
                            : "no-invoice fs-7 ms-auto"
                        }
                      >
                        {s_ele.invoiced ? "Invoiced" : "Not Invoiced"}
                      </p>
                    </div>

                    <div className="d-flex align-items-center">
                      <p className="text-gray v-small">{s_ele.finished_at}</p>

                      <div className="ms-auto">
                        <button
                          className="btn btn-light-outline"
                          onClick={() => {
                            console.log("view");
                          }}
                        >
                          <Link
                            className="text-dark"
                            to={
                              "/outlet/" +
                              id_value.brand_id +
                              "/" +
                              id_value.outlet_id +
                              "/vieworder/" +
                              s_ele.order_id
                            }
                          >
                            View
                          </Link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center">
                <img
                  src={require("../../../assets/img/svg/no_data_2.svg")}
                  className="w-30 pb-2"
                />
                <p className="v-small mb-0">No Service Task</p>
              </div>
            )}
          </div>
          <div className="row py-2">
            <h5 className="fs-7 text-gray fw-bolder">Rework</h5>
            <p>Total Rework :{total_data.total_reworks}</p>
            {rework_data.length > 0 ? (
              rework_data.map((r_ele: any, r_index: any) => (
                <div className="col-md-6 mb-2" key={r_index}>
                  <div className="border p-3">
                    <h6 className="fs-7 mb-3">Task : {r_ele.task_name}</h6>

                    <div className="row align-items-center">
                      <div className="col-6 text-gray">
                        <p className="fs-7">Service : {r_ele.service_name}</p>
                      </div>
                      <div className="col-6 text-end text-gray">
                        <p className="fs-7">Client : {r_ele.client_name}</p>
                      </div>
                    </div>

                    <h6 className="text-dark fs-7 mb-3 fw-bolder">
                      {r_ele.customer_name}
                    </h6>
                    <p className="text-dark fs-7">
                      Finished By : {r_ele.finished_user} @{" "}
                      {r_ele.finished_username}
                    </p>
                    <div className="d-flex">
                      <p
                        className={
                          r_ele.invoiced
                            ? "yes-invoice fs-7 ms-auto"
                            : "no-invoice fs-7 ms-auto"
                        }
                      >
                        {r_ele.invoiced ? "Invoiced" : "Not Invoiced"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="text-gray v-small">{r_ele.finished_at}</p>

                      <div className="ms-auto">
                        <button
                          className="btn btn-light-outline"
                          onClick={() => {
                            console.log("view");
                          }}
                        >
                          <Link
                            className="text-dark"
                            to={
                              "/outlet/" +
                              id_value.brand_id +
                              "/" +
                              id_value.outlet_id +
                              "/vieworder/" +
                              r_ele.order_id
                            }
                          >
                            View
                          </Link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center">
                <img
                  src={require("../../../assets/img/svg/no_data_2.svg")}
                  className="w-30 pb-2"
                />
                <p className="v-small mb-0">No Rework Task</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
